// Mock data matching exact API response shapes from https://pmmcms.touchmedia.net/api/production/
// Used as fallback when Node-RED endpoint is unreachable

export const mockIndustries = [
  { id: 'mock-industry-1', header: 'Manufacturing', label: 'Manufacturing', is_disabled: false },
  { id: 'mock-industry-2', header: 'Retail', label: 'Retail', is_disabled: false },
];

export const mockOfferings = [
  { id: 'mock-offering-fa', header: 'F&A', label: 'F&A', is_disabled: false },
  { id: 'mock-offering-sc', header: 'Supply Chain', label: 'Supply Chain', is_disabled: false },
  { id: 'mock-offering-hr', header: 'T&HR', label: 'T&HR', is_disabled: false },
];

export const mockSubOfferings = [
  { id: 'mock-sub-1', header: 'Plan', label: 'Plan', is_disabled: false },
  { id: 'mock-sub-2', header: 'Deliver', label: 'Deliver', is_disabled: false },
];

export const mockProcesses = [
  { id: 'mock-process-1', header: 'Demand and Supply Planning', label: 'Demand and Supply Planning', is_disabled: false },
];

export const mockRegions = [
  { id: 'mock-region-na', header: 'NA', label: 'NA', icon_url: '', is_disabled: false },
  { id: 'mock-region-emea', header: 'EMEA', label: 'EMEA', icon_url: '', is_disabled: false },
  { id: 'mock-region-apac', header: 'APAC', label: 'APAC', icon_url: '', is_disabled: false },
];

export const mockDataSet = {
  id: 'mock-dataset-1',
  related_region: 'mock-region-na',
  related_process: 'mock-process-1',
  boi_ranges: [
    {
      id: 'mock-boi-1',
      name: 'Forecast Accuracy',
      label: 'Forecast Accuracy',
      comment: 'Sample forecast accuracy metric',
      to_be: null,
      as_is: 75,
      value: 75,
      unit_prefix: '%',
      benchmark: 85,
      min_value: 50,
      max_value: 100,
      is_decreasing: false,
      info_text: 'Measures forecast accuracy percentage',
    },
    {
      id: 'mock-boi-2',
      name: 'Service Level',
      label: 'Service Level',
      comment: 'Fill rate at distribution center',
      to_be: null,
      as_is: 92,
      value: 92,
      unit_prefix: '%',
      benchmark: 95,
      min_value: 80,
      max_value: 100,
      is_decreasing: false,
      info_text: 'Fill rate of articles at DC',
    },
    {
      id: 'mock-boi-3',
      name: 'Inventory Days',
      label: 'Inventory Days',
      comment: 'Days of inventory at DC',
      to_be: null,
      as_is: 65,
      value: 65,
      unit_prefix: 'Days',
      benchmark: 50,
      min_value: 30,
      max_value: 90,
      is_decreasing: true,
      info_text: 'Number of days of inventory at DC',
    },
    {
      id: 'mock-boi-4',
      name: 'On-Time Delivery',
      label: 'On-Time Delivery',
      comment: 'Percentage of on-time deliveries',
      to_be: null,
      as_is: 88,
      value: 88,
      unit_prefix: '%',
      benchmark: 95,
      min_value: 70,
      max_value: 100,
      is_decreasing: false,
      info_text: 'Percentage of deliveries made on time',
    },
  ],
  policy_four_step_ranges: [
    {
      offering: 'Supply Chain',
      sub_offering: 'Plan',
      process: 'Demand and Supply Planning',
      region: 'NA',
      id: 'mock-policy-1',
      name: 'Vendor Management Policies',
      label: 'Vendor Management Policies',
      value: 3,
      info_text: 'Supplier management policies',
      step_one_description: 'BASE - Suppliers managed on need basis',
      step_two_description: 'ENHANCED - Clear policies for supplier scorecards',
      step_three_description: 'ABOVE AVERAGE - Dedicated supplier relations team',
      step_four_description: 'HIGH PERFORMANCE - Suppliers fully integrated',
      value2: 4,
    },
    {
      offering: 'Supply Chain',
      sub_offering: 'Plan',
      process: 'Demand and Supply Planning',
      region: 'NA',
      id: 'mock-policy-2',
      name: 'Demand Planning Policy',
      label: 'Demand Planning Policy',
      value: 2,
      info_text: 'Demand planning governance',
      step_one_description: 'BASE - Ad-hoc demand planning',
      step_two_description: 'ENHANCED - Structured demand review process',
      step_three_description: 'ABOVE AVERAGE - Cross-functional demand planning',
      step_four_description: 'HIGH PERFORMANCE - AI-driven demand sensing',
      value2: 4,
    },
    {
      offering: 'Supply Chain',
      sub_offering: 'Plan',
      process: 'Demand and Supply Planning',
      region: 'NA',
      id: 'mock-policy-3',
      name: 'Inventory Policy',
      label: 'Inventory Policy',
      value: 3,
      info_text: 'Inventory management policies',
      step_one_description: 'BASE - Manual inventory tracking',
      step_two_description: 'ENHANCED - System-driven reorder points',
      step_three_description: 'ABOVE AVERAGE - Dynamic safety stock optimization',
      step_four_description: 'HIGH PERFORMANCE - AI-powered inventory optimization',
      value2: 4,
    },
  ],
  practice_four_step_ranges: [
    {
      offering: 'Supply Chain',
      sub_offering: 'Plan',
      process: 'Demand and Supply Planning',
      region: 'NA',
      id: 'mock-practice-1',
      name: 'Demand Forecasting',
      label: 'Demand Forecasting',
      value: 2,
      info_text: 'Forecast accuracy metrics',
      step_one_description: 'BASE - Manual spreadsheet forecasting',
      step_two_description: 'ENHANCED - Statistical forecasting tools',
      step_three_description: 'ABOVE AVERAGE - Advanced analytics with ML',
      step_four_description: 'HIGH PERFORMANCE - AI-driven demand sensing',
      value2: 4,
    },
    {
      offering: 'Supply Chain',
      sub_offering: 'Plan',
      process: 'Demand and Supply Planning',
      region: 'NA',
      id: 'mock-practice-2',
      name: 'Replenishment',
      label: 'Replenishment',
      value: 3,
      info_text: 'Inventory replenishment practices',
      step_one_description: 'BASE - Reactive replenishment',
      step_two_description: 'ENHANCED - Reorder point driven',
      step_three_description: 'ABOVE AVERAGE - System recommendations',
      step_four_description: 'HIGH PERFORMANCE - Automated replenishment',
      value2: 4,
    },
    {
      offering: 'Supply Chain',
      sub_offering: 'Plan',
      process: 'Demand and Supply Planning',
      region: 'NA',
      id: 'mock-practice-3',
      name: 'S&OP Process',
      label: 'S&OP Process',
      value: 2,
      info_text: 'Sales and operations planning',
      step_one_description: 'BASE - No formal S&OP process',
      step_two_description: 'ENHANCED - Monthly S&OP meetings',
      step_three_description: 'ABOVE AVERAGE - Integrated business planning',
      step_four_description: 'HIGH PERFORMANCE - Real-time IBP with scenario planning',
      value2: 4,
    },
  ],
  platform_four_step_ranges: [
    {
      offering: 'Supply Chain',
      sub_offering: 'Plan',
      process: 'Demand and Supply Planning',
      region: 'NA',
      id: 'mock-platform-1',
      name: 'Planning System',
      label: 'Planning System',
      value: 3,
      info_text: 'Planning system maturity',
      step_one_description: 'BASE - Spreadsheets or basic ERP',
      step_two_description: 'ENHANCED - Automated planning system',
      step_three_description: 'ABOVE AVERAGE - Advanced planning system',
      step_four_description: 'HIGH PERFORMANCE - Industry-specific advanced planning',
      value2: 4,
    },
    {
      offering: 'Supply Chain',
      sub_offering: 'Plan',
      process: 'Demand and Supply Planning',
      region: 'NA',
      id: 'mock-platform-2',
      name: 'Forecasting System',
      label: 'Forecasting System',
      value: 2,
      info_text: 'Forecasting system capabilities',
      step_one_description: 'BASE - No simulation capabilities',
      step_two_description: 'ENHANCED - Advanced forecasting system',
      step_three_description: 'ABOVE AVERAGE - Industry-specific planning system',
      step_four_description: 'HIGH PERFORMANCE - AI-powered planning system',
      value2: 4,
    },
  ],
  project_prioritization_grids: [
    { name: 'P1', label: 'P1', impact: 3, months: 4, text: 'Forecast Improvement Initiative', header: 'Practice' },
    { name: 'P2', label: 'P2', impact: 5, months: 6, text: 'Inventory Optimization Program', header: 'Platform' },
    { name: 'P3', label: 'P3', impact: 8, months: 3, text: 'S&OP Process Enhancement', header: 'Practice' },
    { name: 'P4', label: 'P4', impact: 2, months: 9, text: 'System Integration Project', header: 'Platform' },
  ],
  regional_comparsion: {
    policy: [],
    regions: [],
  },
  regional_comparsion_same_industry: null,
  regional_comparsion_cross_industry: {
    policy: null,
    practice: null,
    platform: null,
  },
};

export const mockLeadIndicators = [
  {
    id: 'mock-lead-1',
    name: 'Forecast Bias',
    label: 'Forecast Bias',
    comment: null,
    to_be: null,
    as_is: 5,
    value: 5,
    unit_prefix: '%',
    benchmark: 3,
    min_value: 0,
    max_value: 20,
    is_decreasing: true,
    info_text: 'Measures systematic over or under forecasting',
  },
  {
    id: 'mock-lead-2',
    name: 'Order Fill Rate',
    label: 'Order Fill Rate',
    comment: null,
    to_be: null,
    as_is: 91,
    value: 91,
    unit_prefix: '%',
    benchmark: 97,
    min_value: 70,
    max_value: 100,
    is_decreasing: false,
    info_text: 'Percentage of orders filled completely on first shipment',
  },
];
